import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.006 16" width="1em" height="1em" {...props}><path d="M6 2a1 1 0 00-.707.293l-5 5a1 1 0 000 1.414l5 5A1 1 0 006 14h8.5s.334.014.697-.168c.364-.182.803-.749.803-1.332v-9c0-.583-.44-1.15-.803-1.332C14.834 1.986 14.5 2 14.5 2zm1.006 3h1.03c.256.011.51.129.688.313l1.282 1.28 1.312-1.28c.266-.231.447-.306.688-.313h1v1c0 .286-.035.55-.25.75l-1.282 1.281 1.25 1.25c.189.188.282.454.282.719v1h-1c-.266 0-.531-.093-.72-.281l-1.28-1.281-1.282 1.28a1.014 1.014 0 01-.718.282h-1v-1c0-.265.093-.53.28-.719l1.282-1.25L7.287 6.75A.909.909 0 017.006 6z" style={{
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" fill="#2e3436" fillRule="evenodd" /></svg>;
}

export default SvgComponent;